// cspell:disable

const languageCodes = ["en", "fr", "es", "de"] as const;
type TosTranslations = { [key in (typeof languageCodes)[number]]: Translation };

interface Translation {
  byPurchasing: string;
  privacyPolicy: string;
  and: string;
  termsAndConditions: string;
  shippingProtectionProvidedBy: string;
  coverageIsSubjectToMerchantReturnPolicy: string;
  coverageIsSubjectToPrefix: string;
  merchantReturnPolicyLinkText: string;
}

export const translations: TosTranslations = {
  en: {
    byPurchasing: "By purchasing coverage, you agree and have read the",
    privacyPolicy: "Privacy Policy",
    and: "and",
    termsAndConditions: "Terms and Conditions",
    coverageIsSubjectToMerchantReturnPolicy:
      "Coverage is subject to Merchant's Return Policy.",
    coverageIsSubjectToPrefix: "Coverage is subject to ",
    merchantReturnPolicyLinkText: "Merchant's Return Policy",
    shippingProtectionProvidedBy: "Shipping protection provided by",
  },
  fr: {
    byPurchasing: "En achetant une protection, vous acceptez et avez lu le",
    privacyPolicy: "Politique de confidentialité",
    and: "et",
    termsAndConditions: "Conditions d'utilisation",
    coverageIsSubjectToMerchantReturnPolicy:
      "La couverture est soumise à la politique de retour du marchand.",
    coverageIsSubjectToPrefix: "La couverture est soumise à la ",
    merchantReturnPolicyLinkText: "politique de retour du marchand",
    shippingProtectionProvidedBy: "Protection de livraison fournie par",
  },
  es: {
    byPurchasing: "Al comprar la cobertura, acepta y confirma haber leído la",
    privacyPolicy: "Política de privacidad",
    and: "y los",
    termsAndConditions: "Términos y condiciones",
    coverageIsSubjectToMerchantReturnPolicy:
      "La cobertura está sujeta a la Política de devolución del comerciante.",
    coverageIsSubjectToPrefix: "La cobertura está sujeta a la ",
    merchantReturnPolicyLinkText: "Política de devolución del comerciante",
    shippingProtectionProvidedBy: "Protección de envío proporcionada por",
  },
  de: {
    byPurchasing:
      "Mit dem Kauf des Schutzes bestätigen Sie, dass Sie die folgenden Dokumente gelesen haben und ihnen zustimmen:",
    privacyPolicy: "Datenschutzrichtlinie",
    and: "und",
    termsAndConditions: "Allgemeine Geschäftsbedingungen",
    coverageIsSubjectToMerchantReturnPolicy:
      "Der Schutz unterliegt der Rückgaberichtlinie des Händlers.",
    coverageIsSubjectToPrefix: "Der Schutz unterliegt der ",
    merchantReturnPolicyLinkText: "Rückgaberichtlinie des Händlers",
    shippingProtectionProvidedBy: "Versandschutz bereitgestellt von",
  },
};
